/* tslint:disable */
/* eslint-disable */
/**
 * chinaone-java
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface AdminStockAdjustLocationAssignReqVo
 */
export interface AdminStockAdjustLocationAssignReqVo {
    /**
     * 当前管理员 ID；兼容现有请求保留，不用于校验箱唛所属会员。
     * 当前管理员ID（兼容字段，不参与库存箱归属过滤）
     * @type {number}
     * @memberof AdminStockAdjustLocationAssignReqVo
     */
    userId: number;
    /**
     * 仓库ID
     * @type {number}
     * @memberof AdminStockAdjustLocationAssignReqVo
     */
    warehouseId: number;
    /**
     * 目标货位ID
     * @type {number}
     * @memberof AdminStockAdjustLocationAssignReqVo
     */
    locationId: number;
    /**
     * 箱唛编号列表
     * @type {Array<string>}
     * @memberof AdminStockAdjustLocationAssignReqVo
     */
    markNos: Array<string>;
}

/**
 * Check if a given object implements the AdminStockAdjustLocationAssignReqVo interface.
 */
export function instanceOfAdminStockAdjustLocationAssignReqVo(value: object): value is AdminStockAdjustLocationAssignReqVo {
    if (!('userId' in value) || value['userId'] === undefined) return false;
    if (!('warehouseId' in value) || value['warehouseId'] === undefined) return false;
    if (!('locationId' in value) || value['locationId'] === undefined) return false;
    if (!('markNos' in value) || value['markNos'] === undefined) return false;
    return true;
}

export function AdminStockAdjustLocationAssignReqVoFromJSON(json: any): AdminStockAdjustLocationAssignReqVo {
    return AdminStockAdjustLocationAssignReqVoFromJSONTyped(json, false);
}

export function AdminStockAdjustLocationAssignReqVoFromJSONTyped(json: any, ignoreDiscriminator: boolean): AdminStockAdjustLocationAssignReqVo {
    if (json == null) {
        return json;
    }
    return {
        
        'userId': json['userId'],
        'warehouseId': json['warehouseId'],
        'locationId': json['locationId'],
        'markNos': json['markNos'],
    };
}

export function AdminStockAdjustLocationAssignReqVoToJSON(json: any): AdminStockAdjustLocationAssignReqVo {
    return AdminStockAdjustLocationAssignReqVoToJSONTyped(json, false);
}

export function AdminStockAdjustLocationAssignReqVoToJSONTyped(value?: AdminStockAdjustLocationAssignReqVo | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'userId': value['userId'],
        'warehouseId': value['warehouseId'],
        'locationId': value['locationId'],
        'markNos': value['markNos'],
    };
}

